import { render, staticRenderFns } from "./check-safe.vue?vue&type=template&id=51a4347a&scoped=true&"
import script from "./check-safe.vue?vue&type=script&lang=js&"
export * from "./check-safe.vue?vue&type=script&lang=js&"
import style0 from "./check-safe.vue?vue&type=style&index=0&id=51a4347a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a4347a",
  null
  
)

export default component.exports